import CatalogList from "./CatalogList";

export default CatalogList;